
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h20v26H5V3zm2 2v22h16V5H7zm7.406 5.344h.031c.33.007.656.135.906.344.257.215.428.498.531.781.207.567.235 1.188.188 1.906-.039.595-.326 1.352-.469 2.031.187.42.248.774.469 1.188.409.766.86 1.217 1.313 1.813.517-.027 1.127-.182 1.563-.125.567.074 1.089.186 1.5.625.206.22.369.553.375.875s-.098.607-.25.875v.031h-.031c-.345.586-.969.976-1.594.938s-1.148-.368-1.625-.781c-.236-.205-.429-.616-.656-.875-.529.06-.906-.001-1.469.125-.537.12-.902.332-1.406.5-.334.672-.599 1.509-.969 2-.4.531-.818.984-1.406 1.188-.294.102-.645.097-.969-.031s-.566-.349-.75-.625c-.372-.529-.404-1.263-.125-1.781s.747-.887 1.281-1.219c.496-.308 1.245-.45 1.875-.688.276-.598.576-.984.813-1.656.275-.783.321-1.455.5-2.219-.35-.837-.787-1.712-.938-2.438-.128-.62-.169-1.181-.031-1.719.069-.269.184-.535.438-.75.246-.208.601-.317.906-.313zm.657 7.406c-.06.184-.061.348-.125.531-.055.157-.13.252-.188.406.048-.011.077-.052.125-.063.285-.064.499-.012.781-.063-.193-.295-.413-.496-.594-.813zm3.687 2.031c-.064-.008-.211.037-.281.031.243.17.495.308.563.313.08.005.096.018.219-.188.012-.021-.007-.015 0-.031-.045-.019-.163-.081-.5-.125zm-7 1.563c-.031.019-.095.044-.125.063-.409.254-.646.522-.719.656s-.103.072 0 .219h.031c.02.03-.012.018 0 .031.071-.03.351-.219.656-.625.054-.072.101-.262.156-.344z"}})])
          )
        }
      }
    